import * as yup from 'yup';
import i18n from 'i18n';

export const contactUsSchema = yup.object().shape({
  name: yup.string().required(() => i18n.t('website:contact.form.validation.nameRequired')),
  email: yup
  .string()
  .trim()
  .required(() => i18n.t('website:contact.form.validation.emailRequired'))
  .matches(
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    () => i18n.t('website:contact.form.validation.emailInvalidFormat')
  )
  .email(() => i18n.t('website:contact.form.validation.emailInvalid')),
  message: yup.string().required(() => i18n.t('website:contact.form.validation.messageRequired')),
});
